const fragmentTypes = require('./schema.gen/fragmentTypes.json');

module.exports = {
  fragmentTypes
};